export default function getPercentOfTimeInDay(time) {
  if (!(time instanceof Date)) return 0;

  const startOfDay = new Date(time);
  startOfDay.setHours(0, 0, 0, 0);

  const endOfDay = new Date(time);
  endOfDay.setHours(24, 0, 0, 0);

  const millisecondsInDay = 24 * 60 * 60 * 1000; // Total milliseconds in a day

  const elapsedTime = time >= startOfDay ? time - startOfDay : endOfDay - time;

  return (elapsedTime / millisecondsInDay) * 100;
}
